import React, { useState, useRef, useEffect } from 'react';
import { Printer, Download, ArrowLeft, Plus, Trash2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const PurchaseOrderReportPrint = () => {
  const printRef = useRef();
  const [isPreviewMode, setIsPreviewMode] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get ID from URL or state (using default "2" for demo)
 const location = useLocation();
 const id = location.state?.orderId || "2";// You can get this from useParams() or location.state

  // Company Data
  const [companyData] = useState({
    name: "Nissi Infotech",
    address: "3/42-12, Nagappa colony, kavundampalayam-636030, Tamil Nadu, India",
    phone: "Phone No: 9003744644",
    email: "Email: infraconsoft-implementation@nissiinfotech.in"
  });

  const [supplierData, setSupplierData] = useState({
    name: "",
    address: "",
    zipCode: "",
    contactPerson: ""
  });
  
  const [orderDetails, setOrderDetails] = useState({
    orderNo: "",
    orderDate: "",
    purchaseRequestNo: "",
    quotationNo: "",
    quotationDate: "",
    gstin: ""
  });
  
  const [items, setItems] = useState([]);
  
  const [totals, setTotals] = useState({
    subTotal: 0,
    discount: 0,
    afterDiscount: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    totalAmount: 0,
    roundOff: 0,
    grandTotal: 0
  });
  
  const [terms, setTerms] = useState({
    price: "",
    delivery: "",
    freight: "",
    warranty: "",
    payment: "",
    otherInstructions: ""
  });

  // Fetch API
  useEffect(() => {
   const fetchData = async () => {
  try {
    setLoading(true);
    setError(null);

    const res = await fetch(`https://www.nissi-india.com/api/purchaseOrder_reportPrint1/${id}`);
    const response = await res.json();
    const data=response.data[0];
    console.log("API Response:", data);

    if (response.success) {
      // Set supplier data - accessing properties directly from data object
      setSupplierData({
        name: data.fld_suppliername || "",
        address: data.fld_address1 || "",
        zipCode: data.fld_ZipCode || data.zipCode || "", // Try both possible field names
        contactPerson: data.fld_contactperson1 || data.contactPerson2 || ""
      });

      // Set order details - accessing from data object or nested orderDetails
      setOrderDetails({
        orderNo: data.fld_POno  || "",
        orderDate: data.fld_Date  || "",
        purchaseRequestNo: data.fld_PurchaseRequestNo  || "",
        quotationNo: data.fld_quotationno || data.orderDetails?.quotationNo || "",
        quotationDate: data.quotationdate || data.orderDetails?.quotationDate || "",
        gstin: data.fld_TIN || data.orderDetails?.gstin || ""
      });

      // Set items - check if data.data is the items array or if items exist separately
      let itemsArray = [];
      if (Array.isArray(response.data)) {
        itemsArray = response.data;
      } else if (response.items && Array.isArray(response.items)) {
        itemsArray = response.items;
      }

      if (itemsArray.length > 0) {
        const processedItems = itemsArray.map((item, index) => ({
          id: item.fld_purchaseorderid || item.fld_id || Date.now() + index,
          sno: item.sno || item.fld_sno || index + 1,
          description: item.fld_itemname || item.fld_description || "",
          hsnNo: item.fld_itemPartNo || item.fld_hsnno || "",
          uom: item.fld_uomname|| item.fld_uom || "Nos",
          qty: parseFloat(item.fld_qty || item.fld_qty) || 0,
          unitPrice: parseFloat(item.fld_ppoprice || item.fld_unitprice) || 0,
          amount: parseFloat(item.amount || item.fld_amount) || 0,
          discount: parseFloat(item.discount || item.fld_discount) || 0,
          taxValue: parseFloat(item.Valuetax || item.fld_taxvalue) || 0,
          totalAmount: parseFloat(item.total || item.fld_totalamount) || 0
        }));
        setItems(processedItems);
      }

      // Set totals - check both nested and flat structure
      const totalsData = data.totals || data;
      setTotals({
        subTotal: parseFloat(totalsData.total || totalsData.fld_subtotal) || 0,
        discount: parseFloat(totalsData.discount || totalsData.fld_discount) || 0,
        afterDiscount: parseFloat(totalsData.afterDiscount || totalsData.fld_afterdiscount) || 0,
        cgst: parseFloat(totalsData.cgst || totalsData.fld_cgst) || 0,
        sgst: parseFloat(totalsData.sgst || totalsData.fld_sgst) || 0,
        igst: parseFloat(totalsData.igst || totalsData.fld_igst) || 0,
        totalAmount: parseFloat(totalsData.fld_pricebasics || totalsData.fld_totalamount) || 0,
        roundOff: parseFloat(totalsData.roundOff || totalsData.fld_roundoff) || 0,
        grandTotal: parseFloat(totalsData.grandTotal || totalsData.fld_grandtotal) || 0
      });

      // Set terms - check both nested and flat structure
      const termsData = data.terms || data;
      setTerms({
        price: termsData.fld_pricebasics || termsData.fld_price || "",
        delivery: termsData.fld_deliverymethod || termsData.fld_delivery || "",
        freight: termsData.fld_frieght|| termsData.fld_freight || "",
        warranty: termsData.fld_warrenty || termsData.fld_warranty || "",
        payment: termsData.fld_payterms|| termsData.fld_payment || "",
        otherInstructions: termsData.otherInstructions || termsData.fld_otherinstructions || ""
      });

    } else {
      setError("No data found for this Purchase Order.");
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    setError("Failed to fetch purchase order details.");
    
    // Set sample data for demo purposes when API fails
    setSupplierData({
      name: "Sample Supplier Ltd.",
      address: "123 Business Street, Industrial Area",
      zipCode: "600001",
      contactPerson: "John Doe"
    });
    
    setOrderDetails({
      orderNo: "PO-2024-001",
      orderDate: "2024-01-15",
      purchaseRequestNo: "PR-2024-001",
      quotationNo: "QT-2024-001",
      quotationDate: "2024-01-10",
      gstin: "33AAAA0000A1Z5"
    });
    
    setItems([
      {
        id: 1,
        sno: 1,
        description: "Sample Product 1",
        hsnNo: "1234",
        uom: "Nos",
        qty: 10,
        unitPrice: 100,
        amount: 1000,
        discount: 0,
        taxValue: 1000,
        totalAmount: 1180
      },
      {
        id: 2,
        sno: 2,
        description: "Sample Product 2",
        hsnNo: "5678",
        uom: "Nos",
        qty: 5,
        unitPrice: 200,
        amount: 1000,
        discount: 0,
        taxValue: 1000,
        totalAmount: 1180
      }
    ]);
    
    setTotals({
      subTotal: 2000,
      discount: 0,
      afterDiscount: 2000,
      cgst: 180,
      sgst: 180,
      igst: 0,
      totalAmount: 2360,
      roundOff: 0,
      grandTotal: 2360
    });
    
    setTerms({
      price: "As per quotation",
      delivery: "15 days from order",
      freight: "Extra as applicable",
      warranty: "1 Year",
      payment: "30 days credit",
      otherInstructions: "Quality as per specification"
    });
  } finally {
    setLoading(false);
  }
};

    if (id) {
      fetchData();
    }
  }, [id]);

  const addNewItem = () => {
    const newItem = {
      id: Date.now(),
      sno: items.length + 1,
      description: "",
      hsnNo: "",
      uom: "Nos",
      qty: 0,
      unitPrice: 0,
      amount: 0,
      discount: 0.0,
      taxValue: 0,
      totalAmount: 0
    };
    setItems([...items, newItem]);
  };

  const removeItem = (id) => {
    const filteredItems = items.filter(item => item.id !== id);
    // Update serial numbers
    const updatedItems = filteredItems.map((item, index) => ({
      ...item,
      sno: index + 1
    }));
    setItems(updatedItems);
  };

  const updateItem = (id, field, value) => {
    setItems(items.map(item => {
      if (item.id === id) {
        const updatedItem = { ...item, [field]: value };
        
        // Recalculate amounts when qty or unitPrice changes
        if (field === 'qty' || field === 'unitPrice') {
          updatedItem.amount = updatedItem.qty * updatedItem.unitPrice;
          updatedItem.taxValue = updatedItem.amount;
          updatedItem.totalAmount = updatedItem.taxValue * 1.18; // Assuming 18% tax
        }
        return updatedItem;
      }
      return item;
    }));
  };

  const handlePrint = () => window.print();
  const handleDownload = () => console.log("Download PDF here");
  const handleBack = () => console.log("Navigate back");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading purchase order...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <p className="text-gray-600">Using sample data for demonstration</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white print:bg-white">
      {/* Header Controls - Hidden in print */}
      <div className="print:hidden bg-gray-50 shadow-sm border-b p-4 no-print">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
            >
              <ArrowLeft size={18} />
              Back
            </button>
            <div className="flex items-center gap-2">
              <button
                onClick={addNewItem}
                className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded text-sm transition-colors"
              >
                <Plus size={16} />
                Add Item
              </button>
              <button
                onClick={() => setIsPreviewMode(!isPreviewMode)}
                className="px-3 py-2 text-blue-600 hover:bg-blue-50 rounded text-sm transition-colors"
              >
                {isPreviewMode ? 'Edit Mode' : 'Preview Mode'}
              </button>
              <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-3 py-2 bg-green-600 text-white hover:bg-green-700 rounded text-sm transition-colors"
              >
                <Download size={16} />
                PDF
              </button>
              <button
                onClick={handlePrint}
                className="flex items-center gap-2 px-3 py-2 bg-gray-800 text-white hover:bg-gray-900 rounded text-sm transition-colors"
              >
                <Printer size={16} />
                Print
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Print Content */}
      <div className="max-w-4xl mx-auto print:max-w-full print:mx-0 p-4 print:p-0">
        <div
          ref={printRef}
          className="bg-white print:bg-white border-2 border-black print:border-2 print:border-black"
        >
          {/* Header with Company Info and Logo */}
          <div className="border-b-2 border-black print:border-b-2 print:border-black">
            <div className="flex">
              {/* Logo Section */}
              <div className="w-24 border-r-2 border-black print:border-r-2 print:border-black flex items-center justify-center p-2">
                <div className="w-16 h-16 bg-gray-200 border border-gray-400 flex items-center justify-center">
                  <span className="text-xs font-bold text-center">LOGO</span>
                </div>
              </div>
              
              {/* Company Info */}
              <div className="flex-1 p-2">
                <div className="text-center">
                  <h1 className="text-lg font-bold">{companyData.name}</h1>
                  <p className="text-sm font-medium">Nissi</p>
                  <p className="text-xs">{companyData.address}</p>
                  <p className="text-xs">{companyData.phone}</p>
                  <p className="text-xs">{companyData.email}</p>
                </div>
              </div>
              
              {/* Purchase Order Title */}
              <div className="w-32 border-l-2 border-black print:border-l-2 print:border-black flex items-center justify-center p-2">
                <div className="text-center">
                  <h2 className="text-sm font-bold">Purchase</h2>
                  <h2 className="text-sm font-bold">Order</h2>
                </div>
              </div>
            </div>
          </div>

          {/* Supplier and Order Details */}
          <div className="flex border-b-2 border-black print:border-b-2 print:border-black">
            {/* Supplier Details */}
            <div className="w-1/2 border-r-2 border-black print:border-r-2 print:border-black p-2">
              <div className="border border-black p-2">
                <h3 className="text-sm font-bold mb-1">To</h3>
                <div className="text-xs space-y-1">
                  {isPreviewMode ? (
                    <>
                      <p className="font-bold">{supplierData.name}</p>
                      <p>{supplierData.address}</p>
                      <p>ZipCode - {supplierData.zipCode}</p>
                      <p>Phone:</p>
                      <p>Email:</p>
                      <p>Contact Person: {supplierData.contactPerson}</p>
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        value={supplierData.name || ""}
                        onChange={(e) => setSupplierData({...supplierData, name: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300 font-bold"
                        placeholder="Supplier Name"
                      />
                      <textarea
                        value={supplierData.address || ""}
                        onChange={(e) => setSupplierData({...supplierData, address: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300"
                        rows="2"
                        placeholder="Address"
                      />
                      <input
                        type="text"
                        value={supplierData.zipCode || ""}
                        onChange={(e) => setSupplierData({...supplierData, zipCode: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300"
                        placeholder="ZipCode"
                      />
                      <input
                        type="text"
                        value={supplierData.contactPerson || ""}
                        onChange={(e) => setSupplierData({...supplierData, contactPerson: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300"
                        placeholder="Contact Person"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Order Details */}
            <div className="w-1/2 p-2">
              <table className="w-full text-xs border-collapse">
                <tbody>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Order No :</td>
                    <td className="px-2 py-1">
                      {isPreviewMode ? (
                        orderDetails.orderNo
                      ) : (
                        <input
                          type="text"
                          value={orderDetails.orderNo || ""}
                          onChange={(e) => setOrderDetails({...orderDetails, orderNo: e.target.value})}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Order Date :</td>
                    <td className="px-2 py-1">
                      {isPreviewMode ? (
                        orderDetails.orderDate
                      ) : (
                        <input
                          type="date"
                          value={orderDetails.orderDate || ""}
                          onChange={(e) => setOrderDetails({...orderDetails, orderDate: e.target.value})}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Purchase Request No :</td>
                    <td className="px-2 py-1">
                      {isPreviewMode ? (
                        orderDetails.purchaseRequestNo
                      ) : (
                        <input
                          type="text"
                          value={orderDetails.purchaseRequestNo || ""}
                          onChange={(e) => setOrderDetails({...orderDetails, purchaseRequestNo: e.target.value})}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Quotation No :</td>
                    <td className="px-2 py-1">{orderDetails.quotationNo || "/"}</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Quotation Date :</td>
                    <td className="px-2 py-1">{orderDetails.quotationDate || "/"}</td>
                  </tr>
                  <tr>
                    <td className="border-r border-black px-2 py-1 font-semibold">GSTIN/UIN:</td>
                    <td className="px-2 py-1">{orderDetails.gstin || "/"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Contact Message */}
          <div className="border-b border-black p-2">
            <p className="text-xs">Dear Sir, Please supply the following items subject to all items and conditions mentioned below</p>
          </div>

          {/* Items Table */}
          <div className="border-b-2 border-black">
            <table className="w-full border-collapse text-xs">
              <thead>
                <tr className="border-b border-black bg-gray-100">
                  <th className="border-r border-black px-1 py-1 text-center">S No</th>
                  <th className="border-r border-black px-1 py-1 text-left">Description</th>
                  <th className="border-r border-black px-1 py-1 text-center">HSN No</th>
                  <th className="border-r border-black px-1 py-1 text-center">UOM</th>
                  <th className="border-r border-black px-1 py-1 text-center">Qty</th>
                  <th className="border-r border-black px-1 py-1 text-center">Unit Price</th>
                  <th className="border-r border-black px-1 py-1 text-center">Amount</th>
                  <th className="border-r border-black px-1 py-1 text-center">Dis%</th>
                  <th className="border-r border-black px-1 py-1 text-center">Tax Value</th>
                  <th className="border-r border-black px-1 py-1 text-center">CGST%</th>
                  <th className="border-r border-black px-1 py-1 text-center">SGST%</th>
                  <th className="border-r border-black px-1 py-1 text-center">IGST%</th>
                  <th className="px-1 py-1 text-center">Total Amt</th>
                  {!isPreviewMode && <th className="print:hidden px-1 py-1 text-center">Action</th>}
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={item.id} className="border-b border-black">
                    <td className="border-r border-black px-1 py-1 text-center">{item.sno}</td>
                    <td className="border-r border-black px-1 py-1">
                      {isPreviewMode ? (
                        item.description
                      ) : (
                        <input
                          type="text"
                          value={item.description || ""}
                          onChange={(e) => updateItem(item.id, 'description', e.target.value)}
                          className="w-full text-xs p-1 border border-gray-300"
                          placeholder="Item description"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">
                      {isPreviewMode ? (
                        item.hsnNo
                      ) : (
                        <input
                          type="text"
                          value={item.hsnNo || ""}
                          onChange={(e) => updateItem(item.id, 'hsnNo', e.target.value)}
                          className="w-full text-xs p-1 border border-gray-300"
                          placeholder="HSN"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">{item.uom}</td>
                    <td className="border-r border-black px-1 py-1 text-center">
                      {isPreviewMode ? (
                        item.qty.toFixed(2)
                      ) : (
                        <input
                          type="number"
                          value={item.qty || 0}
                          onChange={(e) => updateItem(item.id, 'qty', parseFloat(e.target.value) || 0)}
                          className="w-full text-xs p-1 border border-gray-300 text-center"
                          step="0.01"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">
                      {isPreviewMode ? (
                        `₹${item.unitPrice.toFixed(2)}`
                      ) : (
                        <input
                          type="number"
                          value={item.unitPrice || 0}
                          onChange={(e) => updateItem(item.id, 'unitPrice', parseFloat(e.target.value) || 0)}
                          className="w-full text-xs p-1 border border-gray-300 text-center"
                          step="0.01"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">₹{item.amount.toFixed(2)}</td>
                    <td className="border-r border-black px-1 py-1 text-center">{item.discount}</td>
                    <td className="border-r border-black px-1 py-1 text-center">₹{item.taxValue.toFixed(2)}</td>
                    <td className="border-r border-black px-1 py-1 text-center">9.0</td>
                    <td className="border-r border-black px-1 py-1 text-center">9.0</td>
                    <td className="border-r border-black px-1 py-1 text-center">0.0</td>
                    <td className="px-1 py-1 text-center">₹{item.totalAmount.toFixed(2)}</td>
                    {!isPreviewMode && (
                      <td className="px-1 py-1 text-center print:hidden">
                        <button
                          onClick={() => removeItem(item.id)}
                          className="text-red-600 hover:text-red-800 p-1"
                          title="Remove item"
                        >
                          <Trash2 size={12} />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                {/* Add empty rows if items array is empty */}
                {items.length === 0 && (
                  <tr>
                    <td colSpan="14" className="text-center py-4 text-gray-500">
                      No items found. {!isPreviewMode && "Click 'Add Item' to add new items."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Delivery Address and Totals */}
          <div className="flex border-b-2 border-black">
            {/* Delivery Address */}
            <div className="w-1/2 border-r-2 border-black p-2">
              <h3 className="text-sm font-bold mb-2">Delivery Address</h3>
              <div className="text-xs">
                <p className="font-bold">Amount in Words: ₹{totals.grandTotal.toFixed(2)} Only</p>
              </div>
            </div>

            {/* Totals */}
            <div className="w-1/2 p-2">
              <table className="w-full text-xs border-collapse">
                <tbody>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">Sub Total:</td>
                    <td className="px-2 py-1 text-right">₹{totals.subTotal.toFixed(2)}</td>
                    <td className="px-2 py-1">Tot Amount:</td>
                    <td className="px-2 py-1 text-right">₹{totals.totalAmount.toFixed(2)}</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">Discount:</td>
                    <td className="px-2 py-1 text-right">₹{totals.discount.toFixed(2)}</td>
                    <td className="px-2 py-1">PF / Others:</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">A.Dis Total:</td>
                    <td className="px-2 py-1 text-right">₹{totals.afterDiscount.toFixed(2)}</td>
                    <td className="px-2 py-1">Freight:</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">CGST:</td>
                    <td className="px-2 py-1 text-right">₹{totals.cgst.toFixed(2)}</td>
                    <td className="px-2 py-1">Insurance:</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">SGST:</td>
                    <td className="px-2 py-1 text-right">₹{totals.sgst.toFixed(2)}</td>
                    <td className="px-2 py-1">TCS(0.000%):</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">IGST:</td>
                    <td className="px-2 py-1 text-right">₹{totals.igst.toFixed(2)}</td>
                    <td className="px-2 py-1">Round Off (+/-):</td>
                    <td className="px-2 py-1 text-right">₹{totals.roundOff.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td className="px-2 py-1"></td>
                    <td className="px-2 py-1 text-right"></td>
                    <td className="px-2 py-1 font-bold">Grand Total:</td>
                    <td className="px-2 py-1 text-right font-bold">₹{totals.grandTotal.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Terms and Conditions */}
          <div className="border-b-2 border-black p-2">
            <div className="grid grid-cols-2 gap-4 text-xs">
              <div>
                <p><span className="font-bold">PRICE:</span> {terms.price}</p>
                <p><span className="font-bold">DELIVERY:</span> {terms.delivery}</p>
                <p><span className="font-bold">FREIGHT:</span> {terms.freight}</p>
              </div>
              <div>
                <p><span className="font-bold">WARRANTY:</span> {terms.warranty}</p>
                <p><span className="font-bold">PAYMENT:</span> {terms.payment}</p>
                <p><span className="font-bold">OTHER INSTRUCTIONS:</span> {terms.otherInstructions}</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center p-2 border-b border-black">
            <div className="text-xs">
              <p>Received and Accepted terms and conditions</p>
              <p className="mt-4">for SRC PROJECTS PRIVATE LIMITED</p>
            </div>
            <div className="text-xs text-right">
              <p>Authorized Signatory</p>
              <p className="mt-8">SLTNEW002</p>
              <p>01/03/2023 6:14AM</p>
            </div>
          </div>

          <div className="flex justify-between items-center p-2 text-xs">
            <div>
              <p>Authorized Signatory(With Seal)</p>
            </div>
            <div>
              <p>Page 1 of 1</p>
            </div>
          </div>

          <div className="text-center p-1 text-xs bg-gray-100">
            <p>Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com</p>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          @page {
            margin: 0.5in;
            size: A4;
          }
          
          .no-print {
            display: none !important;
          }
          
          body {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          
          * {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
        }
      `}</style>
    </div>
  );
};

export default PurchaseOrderReportPrint;